import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { SOURCE_EMAIL, SOURCE_SMS } from '@whitelabel/xcover-shared/helpers/constants';
import { Loading } from '@whitelabel/component-library';
import { ICustomer } from '@whitelabel/helpers/types';
import { RootState } from '../../store';
import ConfirmSignUpForm from '../forms/ConfirmSignUpForm';
import { StyledSignUpHeadingBlock } from './styled';
import messages from './messages';

interface ISignUp {
  id: string;
  source: typeof SOURCE_SMS | typeof SOURCE_EMAIL;
  loading?: boolean;
  maskedSignUpTokenValid?: boolean;
  signUpToken?: string | null;
  tokenErrorMessage?: string;
  onSubmitOnModal?: any;
  autoFocusPasswordField?: boolean;
  customer?: ICustomer;
}

const Signup = ({
  id,
  source,
  loading = false,
  maskedSignUpTokenValid,
  signUpToken,
  tokenErrorMessage,
  onSubmitOnModal,
  autoFocusPasswordField,
  customer,
}: ISignUp): JSX.Element => {
  const intl = useIntl();
  const customerData: RootState['customer']['data'] = useSelector((state: RootState) => state.customer.data);

  function getErrorMessage() {
    if (maskedSignUpTokenValid === false) {
      return tokenErrorMessage;
    }
    return undefined;
  }

  return (
    <>
      <StyledSignUpHeadingBlock
        title={intl.formatMessage(messages.headingBlockTitle)}
        leadText={intl.formatMessage(messages.headingBlockLeadText)}
        errorMessage={getErrorMessage()}
      />
      {loading ? (
        <Loading />
      ) : (
        <ConfirmSignUpForm
          customer={customer || customerData}
          id={id}
          source={source}
          loading={loading}
          formDisabled={maskedSignUpTokenValid === false}
          signUpToken={signUpToken}
          tokenErrorMessage={tokenErrorMessage}
          onSubmitOnModal={onSubmitOnModal}
          autoFocusPasswordField={autoFocusPasswordField}
        />
      )}
    </>
  );
};

export default Signup;
